import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';
import './PreviewGoodsRefund.less';

export default class PreviewGoodsRefund extends OfficialPage {
  state = {
    goodsList: [],
    selectAll: true,
    is_vip_goods: '',
    dining_partner_source: 0, //餐饮三方订单标识 (1==客如云订单),
    storeStyle: {}
  }
  orderId = ''
  franchiseeId = ''

  constructor(props) {
    super(props);
    document.title = '申请退款';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.orderId = options.orderId
    this.franchiseeId = options.franchisee
    this.getOrderDetail()
  }

  componentDidMount() {
    this.getAppECStoreConfig()
  }

  getOrderDetail = () => {
    var _this = this
    app.getOrderDetail({
      data: {
        order_id: _this.orderId,
        sub_shop_app_id: _this.franchiseeId,
      },
      success: function (res) {
        let goodsData = res.data[0].form_data.goods_info
        let is_vip_goods = res.data[0].vip_cut_price == 0 ? 0 : 1
        for (let i = 0; i < goodsData.length; i++) {
          goodsData[i].preview_refund_num =
            goodsData[i].num - (goodsData[i].refunded_num || '0')
          goodsData[i].preview_refund_num > 0 &&
            goodsData[i].is_benefit_goods != 1
            ? (goodsData[i].selected = true)
            : ''
          goodsData[i].model_value_str = goodsData[i].model_value
            ? goodsData[i].model_value.join('； ')
            : ''
        }
        _this.setData({
          is_vip_goods: is_vip_goods,
          goodsList: goodsData,
          is_group_buy_order: res.data[0].form_data.is_group_buy_order || 0,
          dining_partner_source:
            res.data[0].form_data.dining_partner_source || 0
        })
      }
    })
  }
  clickSelectAll = () => {
    if (this.data.dining_partner_source) {
      return
    }
    var alreadySelect = this.data.selectAll,
      list = this.data.goodsList
    if (alreadySelect) {
      for (var i = list.length - 1; i >= 0; i--) {
        list[i].selected = false
      }
    } else {
      for (var i = list.length - 1; i >= 0; i--) {
        list[i].selected = true
      }
    }
    this.setData({
      selectAll: !alreadySelect,
      goodsList: list
    })
  }
  clickSelectGoods = e => {
    if (this.data.dining_partner_source) {
      return
    }
    var index = e.currentTarget.dataset.index,
      list = this.data.goodsList,
      selectAll = true
    list[index].selected = !list[index].selected
    for (var i = list.length - 1; i >= 0; i--) {
      if (!list[i].selected) {
        selectAll = false
        break
      }
    }
    this.setData({
      goodsList: list,
      selectAll: selectAll
    })
  }
  sureRefund = () => {
    let orderId = this.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsRefundPage/goodsRefundPage?type=apply&orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    let goodsList = this.data.goodsList
    let flag = true
    for (let i = 0; i < goodsList.length; i++) {
      if (goodsList[i].selected) {
        flag = false
      }
    }
    if (flag) {
      app.showModal({
        content: '请选择需要退款的商品'
      })
      return
    }
    app.turnToPage(pagePath)
  }
  clickMinusButton = e => {
    let index = e.currentTarget.dataset.index
    let previewRefundNum = this.data.goodsList[index].preview_refund_num
    if (previewRefundNum - 1 <= 0) {
      return
    }
    if (this.data.dining_partner_source) {
      return
    }
    this.changeGoodsNum(index, 'minus')
  }
  clickPlusButton = e => {
    let index = e.currentTarget.dataset.index
    let previewRefundNum = this.data.goodsList[index].preview_refund_num
    let maxRefundNum =
      this.data.goodsList[index].num -
      (this.data.goodsList[index].refunded_num || '0')
    if (previewRefundNum + 1 > maxRefundNum) {
      return
    }
    if (this.data.dining_partner_source) {
      return
    }
    this.changeGoodsNum(index, 'plus')
  }
  changeGoodsNum = (index, type) => {
    let canRefundNum = this.data.goodsList[index].preview_refund_num
    let targetNum = type == 'plus' ? canRefundNum + 1 : canRefundNum - 1
    let data = {}
    data['goodsList[' + index + '].preview_refund_num'] = targetNum
    this.setData(data)
  }
  inputGoodsCount = e => {
    let index = e.target.dataset.index
    let previewRefundNum = e.target.value
    let data = {}
    let maxRefundNum =
      this.data.goodsList[index].num -
      (this.data.goodsList[index].refunded_num || '0')
    if (previewRefundNum == '') {
      return
    }
    if (previewRefundNum == 0) {
      app.showModal({
        content: '请输入大于0的数字'
      })
      return
    }
    if (previewRefundNum > maxRefundNum) {
      app.showModal({
        content: '当前输入数量大于可退款数量'
      })
      return
    }
    data['goodsList[' + index + '].preview_refund_num'] = previewRefundNum
    this.setData(data)
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.franchiseeId)
  }

  render() {
    const {
      showGetUserInfo,
      goodsList,
      storeStyle,
      is_group_buy_order,
      dining_partner_source,
      selectAll
    } = this.state
    return (
      <div className="official-page preview-goods-refund">
        <TopNav title="申请退款"/>
        <div className="shoppingCart-wrap page" id="shoppingCart">
          <div className="shoppingCart-top-nav">
            <span>退款商品</span>
          </div>
          <div className="shoppingCart-list-wrap">
            <div className="shoppingCart-goods-list">
              {goodsList.map((goods, index) => {
                return (
                  <React.Fragment key={index}>
                    {goods.preview_refund_num > 0 &&
                      goods.is_benefit_goods != 1 && (
                        <div>
                          <label
                            style={convertLineStyleData('color:' + storeStyle.theme)}
                            data-index={index}
                            className={
                              'shoppingCart-check-box ' +
                              (goods.selected
                                ? 'checked ico-moon icon-success-tip'
                                : '')
                            }
                            onClick={this.clickSelectGoods}
                          ></label>
                          <div className="shoppingCart-goods-content">
                            <div className="shoppingCart-goods-cover">
                              <img src={goods.cover} />
                            </div>
                            <div className="goods-content-box">
                              <div className="shoppingCart-goods-title">
                                {is_group_buy_order != 0 && (
                                  <span className="is-seckill">拼团</span>
                                )}
                                {goods.is_seckill == 1 && (
                                  <span className="is-seckill">秒杀</span>
                                )}
                                {goods.is_vip_goods == 1 && (
                                  <span className="is-seckill">会员价</span>
                                )}
                                {goods.goods_name}
                              </div>
                              {goods.model_value_str && (
                                <div className="ellipsis shoppingCart-goods-model">
                                  {goods.model_value_str}
                                </div>
                              )}
                              <div className="shoppingCart-price-box">
                                {goods.use_integral == 0 ? (
                                  <React.Fragment>
                                    <span
                                      style={convertLineStyleData('color:' + storeStyle.theme)}
                                      className="real-price"
                                    >
                                      {'¥' + goods.price}
                                    </span>
                                  </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                      {(goods.price != '0.00' ||
                                        !goods.use_integral ||
                                        goods.use_integral == 0) && (
                                          <span
                                            style={convertLineStyleData('color:' + storeStyle.theme)}
                                            className="real-price"
                                          >
                                            {'¥' + goods.price}
                                          </span>
                                        )}
                                      {goods.use_integral &&
                                        goods.use_integral != 0 &&
                                        goods.price != '0.00' && (
                                          <span
                                            style={convertLineStyleData('color:' + storeStyle.theme)}
                                            className="real-price"
                                          >
                                            +
                                        </span>
                                        )}
                                      {goods.use_integral && (
                                        <span
                                          style={convertLineStyleData('color:' + storeStyle.theme)}
                                          className="real-price"
                                        >
                                          {goods.use_integral + '积分'}
                                        </span>
                                      )}
                                    </React.Fragment>
                                  )}
                                {goods.is_seckill == 1 && (
                                  <span className="seckill-price">
                                    {'¥' + goods.original_price}
                                  </span>
                                )}
                                <div className="goods-number-box pull-right">
                                  <div
                                    className="goods-num-mius"
                                    onClick={this.clickMinusButton}
                                    data-index={index}
                                  >
                                    -
                                  </div>
                                  <input
                                    type="number"
                                    className="goods-num-box"
                                    value={goods.preview_refund_num}
                                    data-index={index}
                                    onInput={this.inputGoodsCount}
                                    disabled={
                                      dining_partner_source ? false : true
                                    }
                                  />
                                  <div
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                    className="goods-num-plus"
                                    onClick={this.clickPlusButton}
                                    data-index={index}
                                  >
                                    +
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </React.Fragment>
                )
              })}
            </div>
          </div>
        </div>
        <div className="shoppingCart-bottom-nav">
          <label
            style={convertLineStyleData('color:' + storeStyle.theme)}
            className={
              'shoppingCart-check-box ' +
              (selectAll ? 'checked ico-moon icon-success-tip' : '')
            }
            onClick={this.clickSelectAll}
          ></label>
          <span className="select-all">全选</span>
          {!!+dining_partner_source && (
            <span className="select-all">（不可部分退款）</span>
          )}
          <div
            style={convertLineStyleData('background:' + storeStyle.theme)}
            className="pull-right sure-refund-btn"
            onClick={this.sureRefund}
          >
            确定
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/preview-goods-refund/PreviewGoodsRefund.jsx